import {
    Admin,
    Privacy,
    Terms,
    ContactUs,
    AboutUs,
    Login,
    SignUp,
    Profile,
    ForgetPassword,
    ProfileDetails,
    Home

  } from './index';
  
  const routeConfigs = [
    { component: Home, path: '/', exact: true },
    { component: Admin, path: '/admin', exact: true },
    { component: Terms, path: '/terms', exact: true },
    { component: Privacy, path: '/privacy', exact: true },
    { component: ContactUs, path: '/contact-us', exact: true },
    { component: AboutUs, path: '/about-us', exact: true },
    { component: Login, path: '/login', exact: true },
    { component: SignUp, path: '/signUp', exact: true },
    { component: Profile, path: '/profile', exact: true },
    { component: ForgetPassword, path: '/forgetPass', exact: true },
    {
        component: ProfileDetails,
        path: '/profile-info/:userId',
        exact: true,
    },
  ];
  
  export const aRoutes = routeConfigs.map((route) => ({
    component: route.component,
    path: route.path,
    exact: route.exact,
  }));
  